import {
  PRINT_RECEIPT_ASYNC,
  SELECT_AGGREGATOR,
  TOGGLE_MODE,
} from "../constants/actionTypesTpos";
import { Aggregator } from "./config";
import { Order } from "./order";

export enum TposMode {
  DRIVE_THRU = "Drive-Thru",
  AGGREGATOR = "Aggregator",
}

export type ACTION_SELECT_AGGREGATOR = {
  type: typeof SELECT_AGGREGATOR;
  payload: Aggregator;
};

export type ACTION_TOGGLE_MODE = {
  type: typeof TOGGLE_MODE;
};

export type ACTION_PRINT_RECEIPT_ASYNC = {
  type: typeof PRINT_RECEIPT_ASYNC;
  payload: Order;
};
